export { TrackingProvider } from './src/ga/TrackingProvider'

export { useTracking, type TrackingContext } from './src/ga/useTracking'

export { useFormTracking, type FormTracker, type TrackedFields } from './src/ga/useFormTracking'

export { usePartnershipTracker } from './src/ga/usePartnershipTracker'

export { BRAND_ACTION, CATEGORY, EVENT_TYPE, SITE, SOCIAL_NETWORK, ACTION } from './src/ga/types'

export * as plausible from './plausible'
